/**
 * @generated SignedSource<<4187acf20b4a6cf469568ed3621031a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateEmployeeRoleInput = {
  employeeIds?: ReadonlyArray<string> | null;
  name?: string | null;
  teamId?: string | null;
};
export type EmployeeRoleEditMainUpdateMutation$variables = {
  id: string;
  input: UpdateEmployeeRoleInput;
};
export type EmployeeRoleEditMainUpdateMutation$data = {
  readonly store: {
    readonly employeeRole: {
      readonly update: {
        readonly role: {
          readonly employees: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
          readonly name: string;
        };
      };
    } | null;
  };
};
export type EmployeeRoleEditMainUpdateMutation = {
  response: EmployeeRoleEditMainUpdateMutation$data;
  variables: EmployeeRoleEditMainUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "EmployeeRoleMutation",
        "kind": "LinkedField",
        "name": "employeeRole",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "UpdateEmployeeRolePayload",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employees",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeRoleEditMainUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeeRoleEditMainUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bab8a149bd6a52407a90c683574af949",
    "id": null,
    "metadata": {},
    "name": "EmployeeRoleEditMainUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeRoleEditMainUpdateMutation(\n  $id: ID!\n  $input: UpdateEmployeeRoleInput!\n) {\n  store {\n    employeeRole(id: $id) {\n      update(input: $input) {\n        role {\n          id\n          name\n          employees {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6dafca263f59602d14e3cf0887ae0e02";

export default node;
